
export default {
  placesAndDirections: {
    'isochrones': 'Izokron vonalak',
    'place': 'hely',
    'notRouteFound': 'A kiválasztott profilban nem lehetett olyan útvonalat találni, amely összeköti a helyeket',
    'notRouteFoundWithFilters': 'A kiválasztott profilban és szűrőkkel nem lehetett olyan útvonalat találni, amely összeköti a helyeket',
    'noPlaceFound': 'A megadott tartalomhoz nem sikerült helyet találni',
    'routeReady': 'Útvonal kész',
    'useLocation': 'GPS',
    'addPlaceInput': 'Hely hozzáadása',
    'clearRoute': 'Útvonal törlése',
    'reverseRoute': 'Megfordítás',
    'orderByClosestPlaces': 'Sorba rendezés az ön helyétől mért távolság szerint',
    'calculatingRoute': 'Útvonal tervezése…',
    'yourLocation': 'Az Ön tartózkodási helye',
    'expandAltitudeChart': 'Diagram kibontása',
    'errorRenderingContentUploaded': 'Hiba történt a feltöltött tartalom megjelenítésekor. Ellenőrizze a fájlformátumot és a tartalmat',
    'roundTrip': 'Körutazás',
    'notPossibleToCalculateRoute': 'Az egyik kiválasztott helyre nem lehetett útvonalat tervezni',
    'apiError': {
      '2000': 'Nem sikerült elemezni a JSON-kérést',
      '2001': 'Hiányzik egy szükséges paraméter',
      '2002': 'Érvénytelen paraméterformátum',
      '2003': 'Az útvonal paraméterei meghaladják az egy vagy több korlátot. Kérjük, ne feledje, hogy néhány elkerülhetőnek vannak korlátai, például az útvonal hossza és az elkerülendő sokszög területe, amely nem haladhatja meg a 20000 négyzetkilométert.',
      '2004': 'Az útvonal paraméterei meghaladják az egy vagy több korlátot. Ne feledje, hogy a hozzávetőleges útvonal nem haladhatja meg a 6000 km -t. Bizonyos útvonal -lehetőségek vagy elkerülhető útvonalak használata esetén a hozzávetőleges útvonal -távolság nem haladhatja meg a 150 km -t.',
      '2006': 'Nem sikerült elemezni az exportkezelő kérését',
      '2007': 'Nem támogatott exportformátum',
      '2008': 'Üres elem',
      '2009': 'Nem lehet megfelelő útvonalat találni a megadott helyekre és feltételekre. Lehet, hogy az alkalmazott szűrőkkel a megadott profil nem támogatott ezen a területen/térségben',
      '2010': 'Nem lehetett olyan megfelelő pontot találni, amely része lenne az útvonalnak. Talán az egyik kiválasztott ponthoz nem lehet útvonalat tervezni, vagy a kiválasztott profil nem támogatott ebben a térségben',
      '2011': 'Alternatív útvonalak használatakor nem lehet megállókat megadni',
      '2012': 'Érvénytelen paraméter lett megadva. Győződjék meg róla, hogy az URL helyes',
      '2099': 'Nem lehet a kiválasztott helyeket összekötő útvonalat tervezni'
    },
    'genericErrorMsg': 'Nem lehetett megtervezni az útvonalat',
    'reorder': 'Átrendezés',
    timeoutError: 'A kérés túl sokáig tartott, és megszakították. Próbálkozzon rövidebb távolságokkal.'
  }
}
